<template>
<div @keydown.ctrl.90="$store.undo($event)" tabindex="0" id="main-tree">

    <div class="menu">
        <div class="row">
            <div class="col s12">
        <label>
            <input type="checkbox" class="filled-in" v-model="displaySecondaryLanguage"/>
            <span>Inspection view</span>
        </label>
        <label style="margin-left:15px">
            <input type="checkbox" class="filled-in" @change="changeDragOption($event)" v-model="$store.moveDialog" ref="moveCheck"/>
            <span>Move dialog on drag</span>
        </label>
        <label style="margin-left:15px">
            <input type="checkbox" class="filled-in" @change="changeReorderOption($event)" v-model="$store.reorder" ref="reorderCheck" />
            <span>Reorder Dialogs</span>
        </label>
        <div v-show="displaySecondaryLanguage" style="width: 20%; display:inline-block; margin-left:2rem">
            <select v-model="secondaryLanguage">
            <option v-if="$store.languages.length > 0" value="" disabled selected>Choose a language</option>
            <option v-if="$store.languages.length == 0">No languages were found</option>
            <option v-for="(language,index) in $store.languages" :key="index" v-bind:value="language.id">{{language.name}}</option>
            </select>
        </div>
        </div>
    </div>

    </div>
    <div class="row" v-show="!initialLoad">
      <div class="col s12">
      <div class="card search-input-list-wrapper" >
      <div style="display:flex">  
      <input type="text" placeholder="Search" v-on:keyup="showSuggestions($event)" v-on:keyup.enter="renderSearchResult(false)" ref="searchInput" v-model="searchQuery" :disabled="searchInputDisabled" required />
      <button v-on:click="renderDefaultSearch()" class="search-button" ><i class="material-icons">restore</i></button>
      </div>
        <div class="search-suggestion-wrapper">
        <Spinner v-if="loadingSuggestions && !initialLoading" :size="'tiny'" style="margin:5px" />
        <ul v-else class="suggestion-list">
          <li v-for="(suggestion,index) in searchSuggestion" :key="index" @click="renderSearchResult(true,suggestion)" @mouseover="changeInputFieldValue(suggestion)">{{suggestion}}</li>
        </ul>
        </div>
      </div>
      </div>
    </div>
    <div class="row">
        <div class="col s12">
            <div class="card" >
                <ul v-show="!loading" class="browser-default dialog-tree-row" >
                    <TreeItem v-for="(dialog, index) in nextDialogs" :key="index" :itemNumber="''" :displaySecondaryLanguage="displaySecondaryLanguage" :secondaryLanguage="secondaryLanguage"  :dialog="dialog" :parentOpen="true"/>
                </ul>
                <div v-if="loading">
                    <h4 class="center-align">Loading dialog editor...</h4>
                    <Spinner class="center"/>
                </div>
            </div>
        </div>
    </div>
    <UploadImage v-if='$store.showUploadImageDialog'/>

</div>
</template>
<style scoped>
#main-tree{
min-height:100vh;
outline:none;
}
.dialog-tree-row {
  list-style-type: none;
  padding-left: 1em;
}
.card {
  padding: 1em;
}
.center {
  position: relative;
  left: 50%;
}
.btn-small {
  height: 28px;
  line-height: 28px;
  font-size: 13px;
  padding: 0 1rem;
  margin-bottom: 2px;
}

.center {
  position: relative;
  left: 50%;
  margin-top: 5%;
}

.menu {
  background-color: #ffffff;
  margin-bottom: 1em;
  border-bottom: #ddd solid 1px;
  padding: 0.5em 0.75rem;
  min-height: 70px;
  line-height: 3em
}

.menu input {
  width: 30%;
  border-radius: 1px;
  border: 1px solid #d9d9d9;
  border-top: 1px solid #c0c0c0;
  font-size: 14px;
  height: 2em;
  padding: 1px 8px;
}

.menu input:focus {
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);
  border: 1px solid #4d90fe;
  outline: none;
  width: 50%;
}

.row {
  margin-bottom: 0 !important;
}
.search-button{
  border:0px;
  background: inherit;
}
.search-button:hover{
  cursor: pointer;
}
.search-suggestion-wrapper{
  background: white;
  box-shadow: 1px 1px 3px dimgray;
}
.suggestion-list{
  margin:0px;
}
.suggestion-list li{
  padding:10px 5px;
}
.suggestion-list li:hover{
  cursor: pointer;
  background:#efefef;
}
.search-input-list-wrapper{
  display:flex;
  flex-direction: column;
}
</style>
<script>
/**
 * View for displaying a dialog tree
 */
import TreeItem from "../components/TreeItem";
import Spinner from "../components/Spinner";
import UploadImage from "../components/UploadImage";
import axios from 'axios';

export default {
  name: "dialogTree",
  components: { TreeItem, Spinner, UploadImage},
  data() {
    return {
      nextDialogs: {},
      loading: true,
      displaySecondaryLanguage: false,
      secondaryLanguage: "",
      defaultNext :[],
      rootDialogId:"",
      cancelSource:null,
      initialLoad:true,
      searchSuggestion:[],
      loadingSuggestions:false,
      initialLoading:true,
      searchInputDisabled:false,
      searchQuery:'',
      searchResultRendered:false
    };
  },
	mounted(){
    this.$store.phrases = [];
    M.FormSelect.init(document.querySelectorAll("select"), {});
	},
	methods: {
  showSuggestions(event){
      if(event.key == 'Enter'){
         return;
      }
      if(this.initialLoading){
        this.initialLoading=false;
      }
      this.loadingSuggestions=true;
      var searchQuery =  this.searchQuery;
      var rootDialog = this.nextDialogs[this.rootDialogId];
      if (this.cancelSource) {
        this.cancelSource.cancel('previous search request cancelled');
      }
      this.cancelSource = axios.CancelToken.source();
      if(searchQuery.length==0){
        this.loadingSuggestions=false;
        this.searchSuggestion=[];
        return;
      }
     this.$http.get('search/searchbar?text=' + searchQuery + '&lang_id='+this.$store.preferredLanguage +'&dialog_type=category,question,instruction', {
        cancelToken: this.cancelSource.token,
        headers: {
          type:'dialog'
        }
      }).then((r) => {
          if (r) {
            this.cancelSource = null;
            this.searchSuggestion = r.data.length ? r.data: ["No search result."];
          }
          this.loadingSuggestions=false;
        }, err => {});
  }, 
  renderSearchResult(suggestionUsed,text) {
     if (this.cancelSource) {
        this.cancelSource.cancel('previous search request cancelled');
        this.cancelSource = null;
        this.loadingSuggestions=false;
      }
    this.searchSuggestion = [];
    var exactMatch;
    if(suggestionUsed){
       exactMatch = true;
       this.searchQuery = text;
    }else{
      exactMatch = false;
      text = this.searchQuery;
    }
     var rootDialog = this.nextDialogs[this.rootDialogId];
     this.loading = true;
     this.searchInputDisabled=true;
     this.$http.get('search/dialogtree?text='+ text + '&lang_id='+this.$store.preferredLanguage + '&is_exactmatch=' + exactMatch + '&dialog_type=category,question,instruction', {
       headers:{
         type:'dialog'
       }
     }).then(r=>{
       this.searchInputDisabled=false;
      //  this.loading=false;
       var searchResultNext = [];
       if(r.data == null)
          r.data = [];
       r.data.forEach(dialog=>{
          searchResultNext.push(dialog.id);
       })
      rootDialog.next = searchResultNext;
      this.searchResultRendered = true;
      this.loading=false;
     })
  },
  renderDefaultSearch(){
  this.cancelSource = null;
  this.searchSuggestion = [];
  this.searchResultRendered = false;
  if(this.searchQuery == "")
    return;
   this.loading = true; 
   this.searchQuery = "";
   var rootDialog = this.nextDialogs[this.rootDialogId];
   rootDialog.next = this.defaultNext;
   var vm = this;
   setTimeout(function(){
     vm.loading = false;
   },1000);   
  },
  changeInputFieldValue(text){
    this.searchQuery = text;
  },
  changeDragOption(event){
  if(this.$store.reorder==true)
  this.$refs.reorderCheck.click();
  if(event.target.checked)
  this.$store.moveDialog=true;
  else
  this.$store.moveDialog=false;
  },
  changeReorderOption(event){
  if(this.$store.moveDialog==true)
  this.$refs.moveCheck.click();
  if(event.target.checked)
  this.$store.reorder=true;
  else
  this.$store.reorder=false;
  },
    /**
     * Retrieves dialogs based on a tag
     * @param {any} tag Tag to use for query
     */
    getDialogByTag(tag) {
      return new Promise((resolve, reject) => {
        this.$http.get("/dialogs?tag=" + tag).then(
          response => {
            
          if(response.data && response.data[0] && response.data[0].next)  
          response.data[0].next.forEach((element)=>{
          this.$set(this.$store.dialogParent,element,response.data[0].id);
          })
            response.data.forEach(element => {

              if (!element.next) element.next = [];
              this.$set(this.nextDialogs, element.id, element);
              this.rootDialogId = element.id;
              this.defaultNext = element.next;
              this.initialLoad=false;
              
            });

            resolve();
          },
          response => {
            reject(response);
          }
        );
      });
    },
    /**
     * Handle incomming dialog update (add or update dialog)
     */
    handleDialogUpdate(dialog) {
      this.$store
        .putDialog(dialog)
        .then(() => {
          this.$set(this.nextDialogs, dialog.id, dialog);
        })
        .catch(() =>
          M.toast({
            html: "Could not update dialog"
          })
        );
    },
  },

  created() {
    this.$on("update:dialog", d => this.handleDialogUpdate(d));
     this.getDialogByTag("start")
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false));
  },
  updated() {
    M.FormSelect.init(document.querySelectorAll("select"), {});
  }
};
</script>



// WEBPACK FOOTER //
// src/views/DialogTree.vue